import {Component, Input, OnChanges, SimpleChanges, ViewChild} from '@angular/core';
import {IonModal} from '@ionic/angular';
import {getStorageImageUrl, normalizeStorageImagePath} from '../../_helpers/storage-image';

@Component({
  selector: 'app-image-preview',
  templateUrl: './image-preview.component.html',
  styleUrls: ['./image-preview.component.scss'],
})
export class ImagePreviewComponent implements OnChanges {
  @Input() selectedFile: string | null | undefined;
  @Input() imageDescription = 'Immagine';
  @Input() contextLabel = 'Immagine risorsa';
  @Input() triggerLabel = 'Apri foto';
  @Input() showTrigger = true;

  @ViewChild(IonModal) modal?: IonModal;

  previewOpen = false;
  imageLoadFailed = false;

  get hasImage(): boolean {
    return Boolean(normalizeStorageImagePath(this.selectedFile)) && !this.imageLoadFailed;
  }

  get imageUrl(): string | null {
    return this.hasImage ? getStorageImageUrl(this.selectedFile) : null;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedFile']) {
      this.imageLoadFailed = false;
      this.previewOpen = false;
    }
  }

  openPreview(event?: Event): void {
    event?.preventDefault();
    event?.stopPropagation();

    if (this.hasImage) {
      this.previewOpen = true;
    }
  }

  async closePreview(): Promise<void> {
    if (this.modal) {
      await this.modal.dismiss();
      return;
    }

    this.previewOpen = false;
  }

  onDidDismiss(): void {
    this.previewOpen = false;
  }

  stopPropagation(event: Event): void {
    event.stopPropagation();
  }

  onImageError(): void {
    this.imageLoadFailed = true;
    void this.closePreview();
  }
}
